module.exports = __webpack_public_path__ + "img/fire.50df8790.svg";